import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'

export default {
  mounted() {
    if (process.browser) {
      gsap.registerPlugin(ScrollTrigger)
      this.revealFromAnimate({ elem: '.reveal' })
      this.animateFromBottom('.from-bottom')
    }
  },
  methods: {
    revealFromAnimate() {
      document.addEventListener('DOMContentLoaded', this.domContentLoaded({ elem: '.reveal' }))
      // document.addEventListener('DOMContentLoaded', this.animateFromBottom('.from-bottom'))
      // document.addEventListener('DOMContentLoaded', this.getBnnerHeight)
    },
    domContentLoaded(o) {
      const that = this
      gsap.utils.toArray(o.elem).forEach(function (elem) {
        that.hide(elem)
        // eslint-disable-next-line no-undef
        ScrollTrigger.create({
          trigger: elem,
          markers: o.markers,
          onEnter() {
            that.animateFrom(elem)
          },
          onEnterBack() {
            that.animateFrom(elem, -1)
          },
          onLeave() {
            that.hide(elem)
          },
          onLeaveBack() {
            that.hide(elem)
          }
        })
      })
    },
    hide(elem) {
      // eslint-disable-next-line no-undef
      gsap.set(elem, { autoAlpha: 0 })
    },
    animateFrom(elem, direction) {
      direction = direction || 1
      let x = 0
      let y = direction * 100
      if (elem.classList.contains('reveal-from-left')) {
        x = -100
        y = 0
      } else if (elem.classList.contains('reveal-from-right')) {
        x = 100
        y = 0
      }
      elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
      elem.style.opacity = '0'
      // eslint-disable-next-line no-undef
      gsap.fromTo(
        elem,
        { x, y, autoAlpha: 0 },
        {
          duration: 1.5,
          x: 0,
          y: 0,
          autoAlpha: 1,
          ease: 'expo',
          overwrite: 'auto'
        }
      )
    },
    // 图片视频从下往上展示动画, 依赖gsap, scrollTrigger
    animateFromBottom(ele) {
      const targets = !ele ? '.from-bottom' : ele
      gsap.utils.toArray(targets).forEach(function (i) {
        gsap.from(i, {
          transform: 'scale(0.9) translateY(20%)',
          opacity: 1,
          scrollTrigger: {
            trigger: i,
            start: 'top bottom',
            end: '+=100',
            scrub: 1
            // markers: true
          }
        })
      })
    }
  },
  destroyed() {
    document.removeEventListener('DOMContentLoaded', this.domContentLoaded({ elem: '.reveal' }))
    // document.removeEventListener('DOMContentLoaded', this.animateFromBottom('.from-bottom'))
  }
}
